module.exports = "/static/assets/777b12b55dd69be2a1707d31774c71d1.gif";